(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero_to_intro_transition"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.querySelector('[data-hti-section]');
  if (!section) return;

  const anim = section.querySelector('[data-hti-anim]');
  const slot = section.querySelector('[data-hti-slot]');
  if (!anim || !slot) return;

  let ticking = false;

  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;

  function update() {
    ticking = false;

    const rect = section.getBoundingClientRect();
    const scrollDist = section.offsetHeight - window.innerHeight;
    const raw = scrollDist > 0 ? (-rect.top / scrollDist) : 1;
    const t = clamp(raw, 0, 1);
    const moveT = clamp(t / 0.72, 0, 1);


    const slotRect = slot.getBoundingClientRect();

    const fromLeft = 0;
    const fromTop = 0;
    const fromW = window.innerWidth;
    const fromH = window.innerHeight;

    const toLeft = slotRect.left;
    const toTop = slotRect.top;
    const toW = slotRect.width;
    const toH = slotRect.height;

    const left = lerp(fromLeft, toLeft, moveT);
    const top = lerp(fromTop, toTop, moveT);
    const w = lerp(fromW, toW, moveT);
    const h = lerp(fromH, toH, moveT);


    anim.style.left = `${left}px`;
    anim.style.top = `${top}px`;
    anim.style.width = `${w}px`;
    anim.style.height = `${h}px`;

    section.style.setProperty('--hti-t', t.toFixed(4));

    const bgLight = clamp((t - 0.25) / 0.45, 0, 1);
    section.style.setProperty('--hti-bg-light-o', bgLight.toFixed(4));
    section.style.setProperty('--hti-bg-dark-o', (1 - bgLight).toFixed(4));

    const textT = clamp((t - 0.62) / 0.28, 0, 1);
    section.style.setProperty('--hti-text-o', textT.toFixed(4));
    section.style.setProperty('--hti-text-y', `${lerp(16, 0, textT).toFixed(2)}px`);

    const mix = clamp((t - 0.78) / 0.18, 0, 1);
    section.style.setProperty('--hti-card-mix', mix.toFixed(4));

    const exitStart = 0.94;
    const exitT = clamp((t - exitStart) / (1 - exitStart), 0, 1);
    section.style.setProperty('--hti-exit-o', (1 - exitT).toFixed(4));
    section.style.setProperty('--hti-exit-y', `${lerp(0, -24, exitT).toFixed(2)}px`);

  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
